
export function activeFieldClass() {
  const formEL = document.querySelectorAll('.gfield input, .gfield textarea, .gfield select');


  if (formEL) {

    [].forEach.call(formEL, function (el) {

      //Add Class form control if needed
      if( el.getAttribute('type') !== "hidden" ){
     
          el.closest('.gfield').classList.add('form-group');
    
        if( el.getAttribute('type') === "checkbox"  || el.getAttribute('type') === "radio" ){
          el.classList.add('form-control--transparent');
          el.classList.add('form-check-input');
          el.parentNode.classList.add('form-check');
          
        }else{
          el.classList.add('form-control');
          el.classList.add('form-control--transparent');
          el.closest('.gfield').classList.add('form-floating');
        }
     }
  
    

      el.addEventListener('focus', function (event) {
        event.target.closest('.gfield').classList.add('active');
      });

      el.addEventListener('blur', function (event) {
        // si le champs n'est pas vide , on garde la class, sinon on l'enlève
        if (event.target.value === "") {
          event.target.closest('.gfield').classList.remove('active');
        }
      })
    })

    // floating label boostrap
    const gfield = document.querySelectorAll('.gfield');
    [].forEach.call(gfield, function (el) {
        el.classList.add('form-group');         
    })
  }

}
